import React from 'react';

const ReportedItems = () => {
    return (
        <div>
            <h2 className='text-2xl text-slate-900'>Reported Items</h2>
            <h2 className='text-xs text-slate-900'>For Admin</h2>
        </div>
    );
};

export default ReportedItems;